/**
 * 旋转动画
 */
import fvAnimation from "./fvAnimation"
export default class fvRotateMove extends fvAnimation {
    constructor(shape){
        super(shape,"fvRotateMove");
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.angleMin = AsyncFunction("return " + this.angleMin);
        this.angleMax = AsyncFunction("return " + this.angleMax);
        this.rightMove = AsyncFunction("return " + this.rightMove);
        this.upMove = AsyncFunction("return " + this.upMove);
        this.lastPos = {
            x:0,
            y:0,
            cx : 0,
            cy :0
        }
        this.isRotateStart = false;
        this.getData();
    }
    async getData(){
        this.angleMinValue = await this.executionScript(this.angleMin);
        this.angleMaxValue = await this.executionScript(this.angleMax);
        this.size = await this.executionScript(this.sizeFunction);
        this.rightMoveValue = await this.executionScript(this.rightMove);
        this.upMoveValue = await this.executionScript(this.upMove);
    }
    async run(canvas,value){
        //if(value == false) return;
        /*旋转*/
        this.getData();
        if(this.angleMinValue < this.angleMaxValue ){
            var viewNum = (parseFloat(this.angleMaxValue) - parseFloat(this.angleMinValue)) * 
                        (this.size - parseFloat(this.rotateMin)) / 
                        (parseFloat(this.rotateMax) - parseFloat(this.rotateMin)) + 
                        parseFloat(this.angleMinValue);
            this.isRotateStart = true;
            if(this.shape.type == "group"){
                canvas.save();
                var angle = viewNum * Math.PI / 180;
                var x = this.shape.x+this.shape.width/2;
                var y = this.shape.y+this.shape.height/2;
                if(this.rightMoveValue != 0){
                    x += parseFloat(this.rightMoveValue);
                }
                if(this.upMoveValue != 0){
                    y -= parseFloat(this.upMoveValue);
                }
                canvas.translate(x,y);
                canvas.rotate(angle);
                canvas.translate(-x,-y);
            }else{
                var cx = parseFloat(this.shape.cx) + 0.5 * parseFloat(this.shape.width);
                var cy = parseFloat(this.shape.cy) + 0.5 * parseFloat(this.shape.height);
                //var cx = parseFloat(this.shape.cx) + 0.5 * parseFloat(this.shape.width);
                //var cy = parseFloat(this.shape.cy) + 0.5 * parseFloat(this.shape.height);
                if(this.rightMoveValue != 0){
                    cx += parseFloat(this.rightMoveValue);
                }
                if(this.upMoveValue != 0){
                    cy -= parseFloat(this.upMoveValue);
                }
                canvas.save();
                var tx = cx*window.devicePixelRatio;
                var ty = cy*window.devicePixelRatio;
                var angle = viewNum * Math.PI / 180;
            
                canvas.translate(tx,ty);
                canvas.rotate(angle);
                //判断旋转的图元的类型， 如果是矩形 不需要置回
                if(canvas.canvas.type=="line"){
                    canvas.translate(-tx,-ty);
                }

                if(this.shape.type == "group"){
                    this.shape.x = -0.5 * parseFloat(this.shape.width);
                    this.shape.y = -0.5 * parseFloat(this.shape.height);
                }else{
                    this.shape.cx = -0.5 * parseFloat(this.shape.width);
                    this.shape.cy = -0.5 * parseFloat(this.shape.height);
                }
            }
            
            //canvas.restore();
        }else{
            this.isRotateStart = false;
        }
    }
    runEnd(canvas){
        if(this.isRotateStart){
            this.isRotateStart = false;
            canvas.restore();
            if(typeof this.shape.formatRect == "function"){
                this.shape.formatRect();
            }
        }
    }
    async runEx(canvas){
        /*旋转*/
        var size = await this.executionScript(this.sizeFunction);
        var angleMinValue = await this.executionScript(this.angleMin);
        var angleMaxValue = await this.executionScript(this.angleMax);
        var rightMoveValue = await this.executionScript(this.rightMove);
        var upMoveValue = await this.executionScript(this.upMove);

        if(Math.abs(rightMoveValue) >= this.shape.initWidth/2){
            if(rightMoveValue<0){
                rightMoveValue = -this.shape.initWidth/2
            }else{
                rightMoveValue = this.shape.initWidth/2
            }
        }
        if(Math.abs(upMoveValue) >= this.shape.initHeight/2){
            if(upMoveValue<0){
                upMoveValue = -this.shape.initHeight/2
            }else{
                upMoveValue = this.shape.initHeight/2
            }
        }
        var viewNum = (parseFloat(angleMaxValue) - parseFloat(angleMinValue)) * 
                    (size - parseFloat(this.rotateMin)) / 
                    (parseFloat(this.rotateMax) - parseFloat(this.rotateMin)) + 
                    parseFloat(angleMinValue);
        if(angleMinValue < angleMaxValue ){
            var px = this.shape.x
            var py = this.shape.y;
            if(this.shape.isSub && this.shape.parent){
                px = this.shape.x - this.shape.parent.x;
                py = this.shape.y - this.shape.parent.y
            }else{
                px = this.shape.x - this.shape.parentObject.x;
                py = this.shape.y - this.shape.parentObject.y
            }
            if(this.shape.fctype == "fvGroupObj"){
                if(this.shape.maxBw && this.shape.maxBw>1){
                    var cx = 0.5 * parseFloat(this.shape.width) + this.shape.cacheCanvas.x + this.shape.maxBw/2+ parseFloat(this.shape.borderWidth)/2;
                    var cy = 0.5 * parseFloat(this.shape.height)+ this.shape.cacheCanvas.y + this.shape.maxBw/2 + parseFloat(this.shape.borderWidth)/2;
                }else{
                    var cx = 0.5 * parseFloat(this.shape.width) + this.shape.cacheCanvas.x ;
                    var cy = 0.5 * parseFloat(this.shape.height) + this.shape.cacheCanvas.y;
                }
                // console.log(this.shape.maxBw/2);
            }else{
                var cx = parseFloat(px) + 0.5 * parseFloat(this.shape.width) + this.shape.cacheCanvas.x + this.shape.maxBw/2+ parseFloat(this.shape.borderWidth)/2;
                var cy = parseFloat(py) + 0.5 * parseFloat(this.shape.height) + this.shape.cacheCanvas.y + this.shape.maxBw/2+ parseFloat(this.shape.borderWidth)/2;
            }
            // var cx = 0.5 * parseFloat(this.shape.width);
            // var cy = 0.5 * parseFloat(this.shape.height);
            if(rightMoveValue != 0){
                cx += parseFloat(rightMoveValue);
            }
            if(upMoveValue != 0){
                cy -= parseFloat(upMoveValue);
            }
            this.shape.preAnimationList["fvRotateMove"] = {
                run:function(){
                    //绘制前执行
                    canvas.save();
                    canvas.translate(cx*window.devicePixelRatio,cy*window.devicePixelRatio);
                    var angle = viewNum * Math.PI / 180;
                    canvas.rotate(angle);
                    canvas.translate(-cx*window.devicePixelRatio,-cy*window.devicePixelRatio);
                }.bind(this)
            }
            this.shape.drawAimation["fvRotateMove"] = {
                run:function(){
                    //绘制后执行
                    canvas.restore();
                }.bind(this)
            }
            super.run();
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvRotateMove.js